/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Merchant } from './merchant';
import { SubModuleCode } from './subModuleCode';


export interface MerchantVsSubscription { 
    createdByName?: string;
    creationTime?: string;
    deleted?: boolean;
    id?: number;
    merchant?: Merchant;
    subscription?: SubModuleCode;
    subscriptionStatus?: MerchantVsSubscription.SubscriptionStatusEnum;
    updateTime?: string;
    updatedByName?: string;
}
export namespace MerchantVsSubscription {
    export type SubscriptionStatusEnum = 'ACTIVE' | 'INACTIVE';
    export const SubscriptionStatusEnum = {
        Active: 'ACTIVE' as SubscriptionStatusEnum,
        Inactive: 'INACTIVE' as SubscriptionStatusEnum
    };
}


